
<template>
  <div class="card-dialog">
    <el-floating
      custom-class="card-floating__body_height el-floating_d-reset"
      width="470px"
      :title="$t('查看订单详情')"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="visibleDialog"
      icon-class="icon-outline_close"
    >
      <Cards
        :statusSticky="false"
        :layoutCards="layoutCards"
        :orderId="orderId"
        :orderData="orderData"
        :progressShow.sync="progressShow"
        @confrimCard="confrimCard"
        @confrimPay="confrimPay"
        @goIconUrl="goIconUrl"
      />
    </el-floating>
  </div>
</template>
<script>
import Cards from './cards.vue';
export default {
  name: 'cardDialog',
  components: {
    Cards,
  },
  model: {
    prop: 'visible',
    event: 'showsChange',
  },
  props: {
    visible: Boolean,
    layoutCards: Object,
    orderId: String,
    orderData: Object,
    progressShow: Boolean,
  },
  computed: {
    visibleDialog: {
      get: function() {
        return this.visible;
      },
      set: function(value) {
        this.$emit('showsChange', value);
      },
    },
  },
  methods: {
    confrimCard() {
      this.$emit('confrimCard');
    },
    confrimPay(val) {
      this.$emit('confrimPay', val);
    },
    goIconUrl(val) {
      this.$emit('goIconUrl', val);
    },
  },
};
</script>
<style lang="scss">
.card-floating__body_height {
  background: #f5f5f7;
  .el-floating__body {
    flex: 1;
    .card-lists{
        padding: 0 12px;
    }
  }
}
</style>
